import { keepPreviousData as e, useMutation as t, useQuery as n, useQueryClient as r } from "@tanstack/react-query";
import { http as i, toQueryParams as a } from "@frontends/data-access-spg-api";
//#region src/lib/api/participantsApi.ts
function o(e) {
	return {
		platform: e.platform,
		externalId: e.external_id,
		displayName: e.display_name,
		username: e.username
	};
}
function s(e) {
	return {
		id: e.id,
		instanceId: e.instance_id,
		status: e.status,
		statusChangedAt: e.status_changed_at,
		currentStepKey: e.current_step_key,
		verifiedEmail: e.verified_email,
		exempt: e.exempt,
		lastInteractionAt: e.last_interaction_at,
		createdAt: e.created_at,
		person: e.user ? o(e.user) : null
	};
}
function c(e) {
	return {
		id: e.id,
		instanceId: e.instance_id,
		person: o(e.user),
		status: e.status,
		statusChangedAt: e.status_changed_at,
		currentStepKey: e.current_step_key,
		language: e.language,
		verifiedEmail: e.verified_email,
		linkedBrands: e.linked_brands ?? [],
		tradingAccounts: e.trading_accounts ?? [],
		presences: e.presences.map((e) => ({
			channelId: e.channel_id,
			state: e.state,
			stateChangedAt: e.state_changed_at,
			grantedAt: e.granted_at,
			joinedAt: e.joined_at,
			leftAt: e.left_at,
			removedAt: e.removed_at,
			removedReason: e.removed_reason
		})),
		graceDeadlineAt: e.grace_deadline_at,
		atRiskRuleId: e.at_risk_rule_id,
		suspendedUntil: e.suspended_until,
		exempt: e.exempt,
		exemptReason: e.exempt_reason,
		firstGrantedAt: e.first_granted_at,
		lastGrantedAt: e.last_granted_at,
		lastRemovedAt: e.last_removed_at,
		lastInteractionAt: e.last_interaction_at,
		createdAt: e.created_at
	};
}
async function l(e, t, n, r) {
	let { data: o } = await i.get("/participations", {
		params: {
			...a(e, t),
			preload: "user",
			...n ? { q: n } : {}
		},
		signal: r
	});
	return {
		data: o.data.map(s),
		total: o.total
	};
}
async function u(e, t) {
	let { data: n } = await i.get(`/participations/${encodeURIComponent(e)}`, { signal: t });
	return c(n);
}
async function d(e) {
	let { data: t } = await i.post(`/participations/${encodeURIComponent(e)}/unblock`);
	return c(t);
}
async function f(e, t, n) {
	let { data: r } = await i.patch(`/participations/${encodeURIComponent(e)}`, {
		exempt: t,
		exempt_reason: n
	});
	return c(r);
}
//#endregion
//#region src/lib/queries.ts
var p = {
	all: ["participants"],
	list: (e, t) => [
		...p.all,
		"list",
		e,
		t
	],
	detail: (e) => [
		...p.all,
		"detail",
		e
	]
};
function m(t, r) {
	let i = [{
		field: "instance_id",
		op: "eq",
		value: r.instanceId
	}];
	return r.status && i.push({
		field: "status",
		op: "eq",
		value: r.status
	}), n({
		queryKey: p.list(t, r),
		queryFn: ({ signal: e }) => l(t, i, r.search.trim(), e),
		placeholderData: e
	});
}
function h(e) {
	return n({
		queryKey: p.detail(e),
		queryFn: ({ signal: t }) => u(e, t)
	});
}
//#endregion
//#region src/lib/mutations.ts
function g(e, t) {
	return e.setQueryData(p.detail(t.id), t), Promise.all([
		e.invalidateQueries({ queryKey: [...p.all, "list"] }),
		e.invalidateQueries({ queryKey: ["decisions"] }),
		e.invalidateQueries({ queryKey: ["retention-rules", "health"] })
	]);
}
function _() {
	let e = r();
	return t({
		mutationFn: d,
		onSuccess: (t) => g(e, t)
	});
}
function v() {
	let e = r();
	return t({
		mutationFn: ({ id: e, exempt: t, reason: n }) => f(e, t, n),
		onSuccess: (t) => g(e, t)
	});
}
//#endregion
export { p as participantsQueryKeys, h as useParticipantQuery, m as useParticipantsQuery, v as useSetExemptMutation, _ as useUnblockParticipantMutation };
